import { GetByFiltersArguments } from "../models/GetByFiltersArguments";
import { Filter } from "../models/Filter";
import { FilterOperators } from "../constants/FilterOperators";
import { FiltersExpressions } from "../constants/FiltersExpressions";
import { SortDirections } from "../constants/SortDirections";
import { AuthorizedUser } from "../models/AuthorizedUser";

export class FiltersArgumentsBuilder {
    private getByFiltersArguments: GetByFiltersArguments;

    constructor() {
        this.initialize();
    }

    private initialize(): void {
        let filters: Filter[] = [];
        let quickSearchFilters: Filter[] = [];
        this.getByFiltersArguments = {
            Tenant: this.getLoggedUserTenant(),
            Filters: filters,
            QuickSearchFilters: quickSearchFilters,
            FiltersExpression: null,
            PageIndex: null,
            PageSize: null,
            SortBy: null,
            SortDirection: null,
            PartnerTypeCode: this.getLoggedUserPartnerTypeCode()
        };
    }

    private getLoggedUserTenant(): number {
        let loggedUserTenant = AuthorizedUser.getTenant();
        if (loggedUserTenant === undefined || loggedUserTenant === null) {
            return -1;
        }
        return loggedUserTenant;
    }

    private getLoggedUserPartnerTypeCode(): string {
        let loggedUserPartnerTypeCode = AuthorizedUser.getPartnerTypeCode();
        if (loggedUserPartnerTypeCode === undefined || loggedUserPartnerTypeCode === null) {
            return "";
        }
        return loggedUserPartnerTypeCode;
    }

    addFilter(filterByField: string,
        fieldValue: string,
        filterOperator: FilterOperators,
        isCustomFilter: boolean = false,
        filterDataType: string | null = null): FiltersArgumentsBuilder {
        let filter: Filter = {
            Property: filterByField,
            Value: fieldValue,
            Operator: filterOperator,
            IsCustomFilter: isCustomFilter,
            FilterDataType: filterDataType
        };
        this.getByFiltersArguments.Filters.push(filter);
        return this;
    }

    addFilters(filters: Filter[]): FiltersArgumentsBuilder {
        this.getByFiltersArguments.Filters.push(...filters);
        return this;
    }

    addQuickSearchFilters(quickSearchFilters: Filter[]): FiltersArgumentsBuilder {
        this.getByFiltersArguments.QuickSearchFilters.push(...quickSearchFilters);
        return this;
    }

    filtersExpression(filtersExpression: FiltersExpressions): FiltersArgumentsBuilder {
        this.getByFiltersArguments.FiltersExpression = filtersExpression;
        return this;
    }

    pageIndex(pageIndex: number): FiltersArgumentsBuilder {
        this.getByFiltersArguments.PageIndex = pageIndex;
        return this;
    }

    pageSize(pageSize: number): FiltersArgumentsBuilder {
        this.getByFiltersArguments.PageSize = pageSize;
        return this;
    }

    sortBy(sortByField: string): FiltersArgumentsBuilder {
        this.getByFiltersArguments.SortBy = sortByField;
        return this;
    }

    sortDirection(sortDirection: SortDirections): FiltersArgumentsBuilder {
        this.getByFiltersArguments.SortDirection = sortDirection;
        return this;
    }

    partnerTypeCode(partnerTypeCode: string): FiltersArgumentsBuilder {
        this.getByFiltersArguments.PartnerTypeCode = partnerTypeCode;
        return this;
    }

    getAll(): FiltersArgumentsBuilder {
        this.getByFiltersArguments.PageIndex = null;
        this.getByFiltersArguments.PageSize = null;
        return this;
    }

    tenant(tenant: number): FiltersArgumentsBuilder {
        this.getByFiltersArguments.Tenant = tenant;
        return this;
    }

    reset(): FiltersArgumentsBuilder {
        this.initialize();
        return this;
    }

    build(): GetByFiltersArguments {
        return this.getByFiltersArguments;
    }
}